import React from 'react';
import ModalHeader from '../molecules/ModalHeader';
import ModalFooter from '../molecules/ModalFooter';
import EmergencyContactForm from '../molecules/EmergencyContactForm';

/**
 * Step6EmergencyContact - Paso 6: Contactos de emergencia
 * NOTA: Este step está comentado en el proyecto original, pero se incluye aquí
 * para que tengas la funcionalidad completa por si la necesitas.
 *
 * Props:
 * - maxPersons: Número máximo de personas/contactos
 * - emergencyContacts: Array de objetos con datos de contactos
 * - onChange: Función callback (index, fieldName, value) => void
 * - errors: Objeto con errores { emergencyContacts: [...] }
 * - onBack: Función callback para volver
 * - onContinue: Función callback para continuar (submit final)
 * - isLoading: Boolean indicando si está procesando
 * - className: Clases CSS adicionales (opcional)
 */
function Step6EmergencyContact({
  maxPersons,
  emergencyContacts = [],
  onChange,
  errors = {},
  onBack,
  onContinue,
  isLoading = false,
  className = ''
}) {
  // Generate array for the number of emergency contacts based on maxPersons
  const emergencyContactIndices = Array.from({ length: maxPersons }, (_, i) => i);

  return (
    <div className={`d-flex flex-column gap-4 rounded w-100 mx-auto ${className}`}>
      <ModalHeader
        title="Completa tu Información"
        subtitle="Contacto de Emergencia"
        currentStep={6}
      />
      <div className="d-flex overflow-x-auto w-100 gap-3 pb-2">
        {emergencyContactIndices.map((index) => (
          <div key={index} className="d-flex flex-column justify-content-center gap-1 w-100">
            {maxPersons > 1 && (
              <h3 className="fs-5 text-dark mb-3">
                Contacto de Emergencia {index + 1}
              </h3>
            )}
            <EmergencyContactForm
              index={index}
              contact={emergencyContacts[index] || {}}
              onChange={onChange}
              errors={errors.emergencyContacts?.[index] || {}}
              className={maxPersons === 1 ? 'w-100' : 'flex-shrink-0'}
              style={maxPersons > 1 ? {minWidth: '320px'} : {}}
            />
            {maxPersons === 1 && (
              <hr className="mt-4" />
            )}
          </div>
        ))}
      </div>
      <ModalFooter
        onBack={onBack}
        onContinue={onContinue}
        continueText="Finalizar Reserva"
        backText="Atrás"
        isLoading={isLoading}
        isSubmit={true}
      />
    </div>
  );
}

export default Step6EmergencyContact;
